import { combineReducers } from 'redux';
import { reducer as auth, IAuthState } from 'reducers/auth';
import { reducer as user, IUserState } from 'reducers/user';
import {
    reducer as materialMaster,
    IMaterialState,
} from 'reducers/materialMaster';
import { reducer as nickname, INickNameState } from 'reducers/nickname';
import { reducer as form } from 'redux-form';
import { reducer as ui } from 'react-redux-ui-tools';
import { IFiltersState, reducer as filters } from 'reducers/filters';
import { reducer as booking, IBookingState } from 'reducers/bookings';
import { reducer as invoices, IInvoicesState } from 'reducers/invoices';
import { reducer as fcr, IDocumentState } from 'reducers/fcr';
import { reducer as exportJob } from 'reducers/exportJob';
import { IExportJobState as IExportJobState } from 'reducers/exportJob';
import { reducer as cbl, ICblState } from 'reducers/cbl';
import { reducer as search, ISearchState } from './search';
import {
    reducer as costRevenue,
    ICostRevenueState,
} from 'reducers/bookings/costRevenue';
import { IUI } from './models';
import { reducer as api, IApiState } from './api';
import { reducer as partners, IPartnersState } from './partners';
import {
    reducer as extraDocument,
    IExtraDocumentConfigurationsState,
} from './extraDocument';
import { reducer as mdm, IMdmState } from './mdm';
import { reducer as vendors, IVendorsState } from './vendors';
import { reducer as historyLog, IHistoryLogState } from './historyLog';
import { reducer as equipments, IEquipmentState } from './equipments';
import { reducer as exceptions, IEMState } from './exception-management';
import { reducer as sap, ISapState } from './sap';
import { reducer as ets, IETSState } from './ets';
import { reducer as featureToggle, IFeatureToggleState } from './featureToggle';
import {
    INewCostRevenueState,
    reducer as newCostRevenue,
} from 'reducers/newCostRevenue';
import {
    reducer as customerToggle,
    ICustomerToggleState,
} from './customerToggle';
import { reducer as vatPartnerEdit } from './vat-partner-edit';
import { IVatPartnersEditState } from './vat-partner-edit/model';
import { reducer as athena } from './athena';
import { IAthena2Point0_State } from './athena/model';
import { reducer as billToParty } from './bill-to-party';
import { IBillToPartyState } from './bill-to-party/model';
import { reducer as downloadSelections } from './download-selections';
import { reducer as editBillToPartyAndVatPartner } from './editBillToPartyAndVatPartner';
import { IEditBillToPartyAndVatPartnerState } from './editBillToPartyAndVatPartner/model';

export interface IStore {
    readonly api: IApiState;
    readonly auth: IAuthState;
    readonly filters: IFiltersState;
    readonly exceptions: IEMState;
    readonly user: IUserState;
    readonly materialMaster: IMaterialState;
    readonly nickname: INickNameState;
    readonly search: ISearchState;
    readonly form: any;
    readonly booking: IBookingState;
    readonly invoices: IInvoicesState;
    readonly costRevenue: ICostRevenueState;
    readonly fcr: IDocumentState;
    readonly ets: IETSState;
    readonly cbl: ICblState;
    readonly equipments: IEquipmentState;
    readonly ui: IUI;
    readonly mdm: IMdmState;
    readonly sap: ISapState;
    readonly partners: IPartnersState;
    readonly vendors: IVendorsState;
    readonly historyLog: IHistoryLogState;
    readonly extraDocument: IExtraDocumentConfigurationsState;
    readonly featureToggle: IFeatureToggleState;
    readonly exportJob: IExportJobState;
    readonly newCostRevenue: INewCostRevenueState;
    readonly customerToggle: ICustomerToggleState;
    readonly vatPartnerEdit: IVatPartnersEditState;
    readonly athena: IAthena2Point0_State;
    readonly billToParty: IBillToPartyState;
    readonly downloadSelections: any;
    readonly editBillToPartyAndVatPartner: IEditBillToPartyAndVatPartnerState;
}

export default combineReducers({
    api,
    auth,
    form,
    filters,
    search,
    fcr,
    cbl,
    ets,
    invoices,
    user,
    nickname,
    exceptions,
    equipments,
    booking,
    partners,
    vendors,
    historyLog,
    costRevenue,
    materialMaster,
    ui,
    mdm,
    sap,
    extraDocument,
    featureToggle,
    exportJob,
    newCostRevenue,
    customerToggle,
    vatPartnerEdit,
    athena,
    billToParty,
    downloadSelections,
    editBillToPartyAndVatPartner,
});